import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card card-profile" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "img/theme/img-1-1000x600.jpg",
  alt: "Image placeholder",
  class: "card-img-top"
}, null, -1)
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "col-lg-3 order-lg-2" }
const _hoisted_5 = { class: "card-profile-image" }
const _hoisted_6 = { href: "#" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4" }, null, -1)
const _hoisted_9 = { class: "card-body pt-0" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "card-profile-stats d-flex justify-content-center" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "heading" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "description" }, "Tickets Abiertos", -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "heading" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "description" }, "Notificaciones", -1)
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "h3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "font-weight-light" }, null, -1)
const _hoisted_22 = { class: "h5 font-weight-300" }
const _hoisted_23 = { class: "ni location_pin mr-2" }
const _hoisted_24 = { class: "h5 mt-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "ni business_briefcase-24 mr-2" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "ni education_hat mr-2" }, null, -1)

import { AuthModule } from "@/store/modules/Auth";
import { NotificationModule } from "@/store/modules/Notification";
import { TicketModule } from "@/store/modules/Ticket";
import { computed } from "vue";
import { env } from "@/config";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const user = computed(() => AuthModule.data.user);
const notifications = computed(
	() => NotificationModule.notifications.filter(n => !n.read).length
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("a", _hoisted_6, [
            _createElementVNode("img", {
              src: _unref(user)?.picture,
              style: {"object-fit":"cover","width":"140px","height":"140px"},
              class: "rounded-circle"
            }, null, 8, _hoisted_7)
          ])
        ])
      ])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            (!_unref(env).onlyCallcenter)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(TicketModule).Rooms.length), 1),
                  _hoisted_15
                ]))
              : _createCommentVNode("", true),
            (!_unref(env).onlyCallcenter)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(notifications)), 1),
                  _hoisted_18
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("h5", _hoisted_20, [
          _createTextVNode(_toDisplayString(_unref(user)?.name), 1),
          _hoisted_21
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("i", _hoisted_23, _toDisplayString(_unref(user)?.organization.status[0] ? _unref(user).organization.status[0].subject : "Indefinido"), 1)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createTextVNode(" " + _toDisplayString(_unref(user)?.organization.tags[0] ? _unref(user)?.organization.tags[0].nombre : "Indefinido") + " - " + _toDisplayString(_unref(user)?.organization?.friendly_name ?? "Indefinido"), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_26,
          _createTextVNode(" " + _toDisplayString(_unref(user)?.organization.status[0] ? _unref(user).organization.status[0].description :
						"Cargo sin especificar"), 1)
        ])
      ])
    ])
  ]))
}
}

})